var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeLightWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 26,
    width: 28,
    height: 8,
    rx: 4,
    fill: "#222222",
    fillOpacity: 0.65
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5779 22C16.4707 22 16.3732 21.972 16.2856 21.916C16.1979 21.86 16.1297 21.7861 16.0809 21.6944C16.0322 21.6028 16.0054 21.5035 16.0006 21.3965C15.9957 21.2896 16.0225 21.1852 16.0809 21.0833L21.4885 11.3056C21.5469 11.2037 21.6224 11.1273 21.715 11.0764C21.8076 11.0255 21.9026 11 22 11C22.0974 11 22.1924 11.0255 22.285 11.0764C22.3776 11.1273 22.4531 11.2037 22.5115 11.3056L27.9191 21.0833C27.9775 21.1852 28.0043 21.2896 27.9994 21.3965C27.9946 21.5035 27.9678 21.6028 27.9191 21.6944C27.8703 21.7861 27.8021 21.86 27.7144 21.916C27.6268 21.972 27.5293 22 27.4221 22H16.5779ZM22 20.1667C22.1656 20.1667 22.3045 20.1081 22.4165 19.991C22.5286 19.8738 22.5846 19.7287 22.5846 19.5556C22.5846 19.3824 22.5286 19.2373 22.4165 19.1201C22.3045 19.003 22.1656 18.9444 22 18.9444C21.8344 18.9444 21.6955 19.003 21.5835 19.1201C21.4714 19.2373 21.4154 19.3824 21.4154 19.5556C21.4154 19.7287 21.4714 19.8738 21.5835 19.991C21.6955 20.1081 21.8344 20.1667 22 20.1667ZM22 18.3333C22.1656 18.3333 22.3045 18.2748 22.4165 18.1576C22.5286 18.0405 22.5846 17.8954 22.5846 17.7222V15.8889C22.5846 15.7157 22.5286 15.5706 22.4165 15.4535C22.3045 15.3363 22.1656 15.2778 22 15.2778C21.8344 15.2778 21.6955 15.3363 21.5835 15.4535C21.4714 15.5706 21.4154 15.7157 21.4154 15.8889V17.7222C21.4154 17.8954 21.4714 18.0405 21.5835 18.1576C21.6955 18.2748 21.8344 18.3333 22 18.3333Z",
    fill: "#FAAD14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeLightWarning);
export default __webpack_public_path__ + "static/media/we-light-warning.3491e05f9098326cbb4072f51102cd1b.svg";
export { ForwardRef as ReactComponent };